import {
  CircularProgress,
  DialogActions,
  DialogTitle,
  Divider,
  Grid,
  Dialog,
  Button,
  DialogContent,
} from '@mui/material'
import { useEffect, useRef, useState } from 'react'
import { metodoPrograma } from '../../../../../../components/api'
import { setError } from '../../../../../../components/alerts'

const ModalConfirmacaoSenha = ({ data, close }) => {
  const {
    metodo = 'registraAplicacaoAgendamento',
    titulo = 'Registro de Aplicação',
    descricao = 'Utilize o teclado normal e tecle sua senha numérica para confirmar o registro de aplicação',
    textoConfirmar = 'Registrar aplicação',
    setReloadAtendimento,
    onSuccess,
    ...parametros
  } = data
  const inputRef = useRef(null)
  const [loading, setLoading] = useState(false)
  const [dsSenha, setDsSenha] = useState('')
  const [teclado, setTeclado] = useState([])
  const MAX_DIGITOS = 6

  const handleFalse = () => {
    close(false)
  }

  const gerarTeclado = () => {
    const numeros = Array.from({ length: 10 }, (_, i) => i)

    const embaralhado = numeros.sort(() => Math.random() - 0.5)

    setTeclado(embaralhado)
  }

  useEffect(() => {
    gerarTeclado()

    const timer = setTimeout(() => {
      inputRef.current?.focus()
    }, 100)

    return () => clearTimeout(timer)
  }, [])

  const confirmarComSenha = async () => {
    if (dsSenha === '') {
      setError('Informe sua senha')
      return
    }

    setLoading(true)
    const resp = await metodoPrograma(metodo, {
      ...parametros,
      dsSenha,
    })

    if (resp.status) {
      setReloadAtendimento?.((v) => !v)
      await onSuccess?.(resp)
      close(true)
    }
    setLoading(false)
  }

  const adicionarNumero = (num) => {
    setDsSenha((prev) => {
      if (prev.length >= MAX_DIGITOS) return prev
      return prev + num
    })
  }

  const limparSenha = () => {
    setDsSenha('')
  }

  useEffect(() => {
    const timer = setTimeout(() => {
      inputRef.current?.focus()
    }, 100) // pequeno delay ajuda com Dialog

    return () => clearTimeout(timer)
  }, [])

  return (
    <Dialog maxWidth="md" fullWidth open={true} onClose={handleFalse}>
      <DialogTitle divider>{titulo}</DialogTitle>
      <Divider />
      <DialogContent divider>
        <Grid container spacing={2}>
          <Grid item xs={12} sx={{ textAlign: 'center' }}>
            <div>{descricao}</div>
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                gap: 12,
                marginTop: 50,
                width: '100%',
              }}
            >
              {Array.from({ length: 6 }).map((_, index) => {
                const filled = index < dsSenha.length

                return (
                  <div
                    key={index}
                    style={{
                      width: 18,
                      height: 18,
                      borderRadius: '50%',
                      border: '2px solid #555',
                      backgroundColor: filled ? '#1976d2' : 'transparent',
                      transition: 'all 0.2s ease',
                    }}
                  />
                )
              })}
            </div>
          </Grid>
          <Grid item xs={12} style={{ marginTop: 50 }}>
            <Grid container spacing={1} justifyContent="center">
              {teclado.map((num, index) => (
                <Grid item xs={1} key={index}>
                  <Button
                    fullWidth
                    variant="outlined"
                    onClick={() => adicionarNumero(num)}
                  >
                    {num}
                  </Button>
                </Grid>
              ))}

              <Grid item xs={1}>
                <Button fullWidth variant="outlined" onClick={limparSenha}>
                  ⌫
                </Button>
              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} style={{ marginTop: 50 }}></Grid>
        </Grid>
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button fullWidth variant="contained" onClick={handleFalse}>
          fechar
        </Button>
        <Button
          fullWidth
          variant="contained"
          onClick={confirmarComSenha}
          disabled={loading || dsSenha.length < 6}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {textoConfirmar}
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ModalConfirmacaoSenha
